<template>
    <div class="o-wrapper">
        <div class="o-grid" :class="cards.length === 0 ? 'o-grid--center' : ''">
            <div v-if="cards.length !== 0 || showPlaceholders" class="o-grid__item u-width-full">
                <div class="cards__wrapper">
                    <div class="cards" id="cards">
                        <content-placeholders v-if="showPlaceholders"></content-placeholders>
                        <post-card-api
                            v-for="card in cards"
                            :key="card.id"
                            :card="card"
                        ></post-card-api>
                    </div>
                </div>
            </div>
            <div v-else class="o-grid__item u-width-8/12 u-width-full@l" v-if="showEmptyMessage">
                <div class="c-empty-state">
                    <h4>No reposts yet</h4>
                    <p>Articles you repost to other communities will appear here.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PostCardApi from "../PostCardApi";
import MasonryStore from "../../configs/masonry-store";
import ContentPlaceholders from "../ContentPlaceholders.vue";

export default {
    components: {
        ContentPlaceholders,
        PostCardApi,
    },
    data() {
        return {
            cards: [],
            loading: false,
            masonry: MasonryStore,
            next: true,
            page: 1,
            showEmptyMessage: false,
            showPlaceholders: false,
        };
    },
    created() {
        if (this.$root.user === false || this.$root.user.username !== this.$root.profile.username) {
            this.$router.replace('/u/' + this.$root.profile.username);
            return;
        }
        this.$root.$on('profile-search-reposts', (search) => {
            this.fetchData(search);
        });
        this.fetchData();
    },
    updated() {
        this.$nextTick(() => {
            this.masonry.load();
        });
    },
    mounted() {
        window.addEventListener('scroll', this.loadPostsOnScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.loadPostsOnScroll);
    },
    methods: {
        fetchData(search) {
            if (this.loading) {
                return;
            }
            const isSearchCall = search !== undefined;
            const cacheKey = this.$simpleStore.localStorageCacheKeys.reposts;
            if (!isSearchCall) {
                if (this.showEmptyMessage) return;
                const cached = this.$simpleStore.getWithSlidingExpiry(cacheKey);
                if (cached != null) {
                    this.cards = cached;
                    if (this.cards.length === 0) {
                        this.showEmptyMessage = true;
                    }
                    return;
                }
            } else {
                this.cards = [];
                this.page = 1;
                this.showEmptyMessage = false;
                window.addEventListener('scroll', this.loadPostsOnScroll);
                this.$root.$emit('bus-profile-search-loading', true);
            }
            this.showPlaceholders = this.page === 1;
            this.loading = true;
            this.$http.post('/api/v1/posts/reposted-by-user', {
                user_id: this.$root.profile.user_id,
                page: this.page,
                search: search || '',
            }).then(response => {
                this.loading = false;
                this.showPlaceholders = false;
                if (isSearchCall) {
                    this.$root.$emit('bus-profile-search-loading', false);
                }
                const newCards = response.data.cards || [];
                if (this.cards.length === 0 && newCards.length === 0) {
                    this.showEmptyMessage = true;
                    // cache the empty result so a repost-less profile doesn't
                    // re-fetch (and flash placeholders) on every tab visit
                    if (!isSearchCall) {
                        this.$simpleStore.setWithExpiry(cacheKey, []);
                    }
                    return;
                }
                this.cards.push.apply(this.cards, newCards);
                this.next = response.data.total_pages > this.page;
                this.page++;
                if (!this.next) {
                    window.removeEventListener('scroll', this.loadPostsOnScroll);
                }
                if (!isSearchCall) {
                    this.$simpleStore.setWithExpiry(cacheKey, this.cards);
                }
            }, response => {
                this.loading = false;
                this.showPlaceholders = false;
                if (isSearchCall) {
                    this.$root.$emit('bus-profile-search-loading', false);
                }
                if (response.status === 403) {
                    this.$root.$emit('show-private-message');
                }
            });
        },
        loadPostsOnScroll() {
            if (this.loading === false && this.next) {
                const percentageScroll = (Math.max(window.scrollY, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight) / document.documentElement.offsetHeight;
                if (percentageScroll > 0.9) {
                    this.fetchData();
                }
            }
        },
    },
};
</script>
